import { Outlet } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

export const AuthLayout = () => {
  return (
    <main className="relative flex flex-col items-center justify-center">
      <section className="flex min-h-screen w-full flex-1 flex-col items-center justify-center px-4 py-8">
        <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md">
          <div className="flex justify-center mb-6">
            <LazyLoadImage
              src="https://site-moveis-imgs.s3.sa-east-1.amazonaws.com/conceito-design/company-info/conceitodesign2.png"
              alt="Logo da Conceito Design"
              className="h-56"
              effect="blur"
            />
          </div>
          <Outlet />
        </div>
      </section>
    </main>
  );
}